export const GET_COLOR_PALETTE_BLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    colorPaletteBlock(id: "${id}", preview: ${preview}) {
      sys {
        id
      }
      heading
      selectedPalette
      paletteDescription{json}
    }
  }
`;
